<template>
  <section class="footerPage">
    <img class="footerPageImage" :src="image" alt="highgrounds-footer-image">
    <img class="footerPageLogo" :src="logo" alt="highgrounds-logo">
    <div class="footerPageTinter"></div>
  </section>
</template>

<script>
import HGMainFooter from '@/assets/hgMain/hgMainFooter.jpg';
import HGMainFooterLogo from '@/assets/hgMain/footerLogo.svg';

export default {
  name: 'FooterPage',
  data() {
    return {
      image: HGMainFooter,
      logo: HGMainFooterLogo
    }
  },
}
</script>

<style scoped>
.footerPage {
  position: relative;
}
.footerPageImage {
  height: auto;
  width: 100%;
}
.footerPageLogo {
  position: absolute;
  display: block;
  justify-content: center;
  bottom: 50%;
  right: 15%;
  z-index: 2;
  height: auto;
  width: 70%;
}
.footerPageTinter {
  background-image: linear-gradient(
    to top,
    #1E1E1E 0%,
    #1E1E1E 10%,
    rgb(0,0,0,0.0) 60%
    );
    position: absolute;
    bottom: 0;
    height: 100%;
    width: 100%;
}
</style>
